import { StoreAction, XmAction } from 'store/actions';
import { UsageDetail, UsageSummary } from './models';

export function usageDetailReducer(state: UsageDetail[] = [], action: XmAction<UsageDetail>): UsageDetail[] {
    switch (action.type) {
        case StoreAction.GET_USAGE_DETAIL:
            return [ ...state, action.payload ];
        default:
            return state;
    }
}

export function usageSummaryReducer(state: UsageSummary[] = [], action: XmAction<UsageSummary>): UsageSummary[] {
    switch (action.type) {
        case StoreAction.GET_USAGE_SUMMARY:
            return [ ...state, action.payload ];
        default:
            return state;
    }
}
